import { useEffect } from 'react';

const blogScripts = [
    "/assets/js/vendor/modernizr-3.6.0.min.js",
    "/assets/js/vendor/jquery-1.12.4.min.js",
    "/assets/js/popper.min.js",
    "/assets/js/bootstrap.min.js",
    "/assets/js/slick.min.js",
    "/assets/js/jquery.nice-select.min.js",
    "/assets/js/isotope.pkgd.min.js",
    "/assets/js/imagesloaded.pkgd.min.js",
    "/assets/js/jquery.magnific-popup.min.js",
    "/assets/js/main.js"
];

export default function useBlogScripts() {
    useEffect(() => {
        let isMounted = true;

        const loadScriptsSequentially = async () => {
            for (const src of blogScripts) {
                if (!isMounted) break;
                const existingScript = document.querySelector(`script[src="${src}"]`);
                if (!existingScript) {
                    await new Promise((resolve) => {
                        const script = document.createElement('script');
                        script.src = src;
                        script.async = false;
                        script.onload = () => resolve();
                        script.onerror = () => resolve();
                        document.body.appendChild(script);
                    });
                }
            }
        };

        loadScriptsSequentially();

        return () => {
            isMounted = false;
        };
    }, []);
}
